/**
* 头部菜单
*/ 
<template>
  <el-menu class="el-menu-demo" mode="horizontal" background-color="#334157" text-color="#fff" active-text-color="#fff">
    <el-button class="buttonimg">
      <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
    </el-button>
    <el-submenu index="2" class="submenu">
      <!-- <template slot="title">{{user.userRealName}}</template> -->
      <template slot="title"><img :src="user.avatar" alt="" class="image1">{{user.name}}</template>
      <el-menu-item @click="exit()">退出</el-menu-item>
    </el-submenu>
  </el-menu>
</template>
<script>
import { loginOut } from '../api/common'
import {getUserInfo} from "../api/user";
export default {
  name: 'navcon',
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user: {}
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    getUserInfo({}).then(res => {
      if (res.resultCode.code !== '00000') {
        this.$message({
          type: 'info',
          message: res.resultCode.cnMsg
        })
      } else {
        this.user = res.result
      }
    })
  },
  methods: {
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '退出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          loginOut({})
                  .then(res => {
                    setTimeout(() => {
                      this.$message({
                        type: 'success',
                        message: '已退出登录!'
                      })
                      localStorage.removeItem('logintoken')
                      localStorage.removeItem('user')
                      this.$router.push({ path: '/login' })
                    }, 1000)
                  });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    }
  }
}
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
.image1{
  width:50px;
  height:50px;
  border-radius:25px;
}

</style>


// WEBPACK FOOTER //
// src/components/navcon.vue